/** We can do further Chrome checking here to see if the extension is installed */
const isChrome = (): boolean => 'chrome' in window
export default isChrome
